import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { useQuery } from '@tanstack/react-query';

export const GET_ROOT_ASSET_COUNT_QUERY_KEY = 'folders.getRootAssetCount';

export const useGetRootAssetCount = ({ enabled = true }: { enabled?: boolean } = {}) => {
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();

  const { data, isLoading, error } = useQuery({
    queryKey: [GET_ROOT_ASSET_COUNT_QUERY_KEY, { tenantId }],
    queryFn: () => api.folders.listRootContents({ tenantId, contentType: 'assets', page: 1, perPage: 1 }),
    select: response => response.data.pageData.total,
    enabled: enabled && !!tenantId,
  });

  return {
    rootAssetCount: data,
    isLoading,
    error,
  };
};
